import { getQueryParams } from './fp/route/queryParams';
import { isEmpty } from './fp';
import { ReadonlyURLSearchParams } from 'next/navigation';

export const getHomeQueryParams = (searchParams: ReadonlyURLSearchParams) => {
    const urlSearchParams = new URLSearchParams(searchParams ?? {});

    const lowerCaseSearchParams = Array.from(urlSearchParams.entries()).reduce(
        (acc, [key, value]) => ({ ...acc, [key.toLowerCase()]: value }),
        {} as Record<string, string>,
    );

    const onlyLastQueryParam = (params?: string) =>
        !params || isEmpty(params) ? undefined : params.split(',').pop();

    const convertToNumber = (param?: string) => (param ? Number(param) : undefined);

    const {
        status,
        esid,
        euid,
        reg_type,
        r_type,
        reg_id,
        r_id,
        t,
        hhid,
        hh_id,
        source,
        token,
        s,
        message,
        template_id,
    } = getQueryParams(new URLSearchParams(lowerCaseSearchParams) as ReadonlyURLSearchParams)(
        ...Object.keys(lowerCaseSearchParams),
    );

    const surveyStatus = convertToNumber(onlyLastQueryParam(status));
    const registrationId = onlyLastQueryParam(reg_id) || onlyLastQueryParam(r_id);
    const registrationType =
        onlyLastQueryParam(reg_type) || onlyLastQueryParam(r_type) || onlyLastQueryParam(t);
    const templateId = convertToNumber(onlyLastQueryParam(template_id));
    const externalSourceId = convertToNumber(onlyLastQueryParam(esid));
    const externalUserId = convertToNumber(onlyLastQueryParam(euid));
    const howHeardId =
        convertToNumber(onlyLastQueryParam(hhid)) ||
        convertToNumber(onlyLastQueryParam(hh_id)) ||
        convertToNumber(onlyLastQueryParam(source));
    const nonMemberToken = onlyLastQueryParam(token);
    const messageIdToShow = convertToNumber(onlyLastQueryParam(message));
    const savedPaymentDetails = convertToNumber(onlyLastQueryParam(s));

    return {
        surveyStatus,
        registrationId,
        registrationType,
        templateId,
        externalSourceId,
        externalUserId,
        howHeardId,
        nonMemberToken,
        savedPaymentDetails,
        messageIdToShow,
    };
};
